export default {"src":"/login-app/[GIT_HASH]/_next/static/media/token.8d757929.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};